import { MarketingWebsiteFaqEntry, MarketingWebsitePageId } from '@core/seo/marketing-website-seo.models';
import { MarketingWebsiteSeoConfig } from '@core/seo/marketing-website-seo.models';
import { marketingPathForPageId } from '@core/seo/marketing-website-seo.utils';

export interface WebsiteMarketingCopy {
  readonly docTitle: string;
  readonly metaDescription: string;
  readonly heroTitle: string;
  readonly heroSub: string;
  readonly body?: readonly string[];
  readonly faq?: readonly MarketingWebsiteFaqEntry[];
  readonly ctaLabel?: string;
}

export function buildWebsiteMarketingSeoConfig(
  pageId: MarketingWebsitePageId,
  copy: WebsiteMarketingCopy,
  origin?: string
): MarketingWebsiteSeoConfig {
  return {
    pageId,
    path: marketingPathForPageId(pageId),
    documentTitle: copy.docTitle,
    metaDescription: copy.metaDescription,
    faqEntries: copy.faq,
    origin,
  };
}

export const WEBSITE_HOME_FAQ_KEYS = [
  'what',
  'trial',
  'card',
  'rubros',
  'grow',
  'easy',
] as const;

export type WebsiteHomeFaqKey = (typeof WEBSITE_HOME_FAQ_KEYS)[number];

export const WEBSITE_PRICING_FAQ_KEYS = [
  'free',
  'vender',
  'change',
  'trial',
  'extras',
  'cancel',
] as const;

export type WebsitePricingFaqKey = (typeof WEBSITE_PRICING_FAQ_KEYS)[number];

export function buildWebsiteFaqEntries(
  keys: readonly WebsiteHomeFaqKey[],
  translate: (key: string) => string
): MarketingWebsiteFaqEntry[] {
  return keys.map((key) => ({
    question: translate(`website.faq.${key}.q`),
    answer: translate(`website.faq.${key}.a`),
  }));
}

export function buildWebsitePricingFaqEntries(
  keys: readonly WebsitePricingFaqKey[],
  translate: (key: string) => string
): MarketingWebsiteFaqEntry[] {
  return keys.map((key) => ({
    question: translate(`website.pricing.faq.${key}.q`),
    answer: translate(`website.pricing.faq.${key}.a`),
  }));
}
